export function propertyNameOf<TObj>(name: keyof TObj) {
	return name;
}
